module.exports = __webpack_public_path__ + "img/member.bc843035.png";